// src/SearchText.js
import React, { useState } from 'react';

// Este componente recibe 'apiUrl' y 'onResults' (la función callback para enviar datos al padre).
function SearchText({ apiUrl, onResults }) {
    
    // [CONCEPTO REACT: useState] 
    // Los 'Hooks' de React (empiezan con 'use') le dan funcionalidad a los componentes.
    // Aquí declaramos variables de estado: 'query' (el texto del input), 'loading', y 'error'.
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Función que se dispara al hacer clic en 'Buscar'.
    const performSearch = async (e) => {
        e.preventDefault(); // Evita que la página se recargue (comportamiento estándar de un formulario).
        
        if (!query.trim()) {
            setError('Por favor, ingresa un valor de búsqueda.');
            return;
        }

        setLoading(true); // Mostrar que estamos cargando
        setError(null);

        try {
            // [LÓGICA: FETCH a la API]
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ query: query })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || `Error del servidor (${response.status})`);
            }
            
            // Llama a la función del componente padre (App.js) para mostrar los resultados.
            if (data && Array.isArray(data.results)) {
                onResults(data.results);
            } else {
                onResults([]);
            }

        } catch (err) {
            setError(err.message || 'Error al conectar con el API Gateway.');
            onResults(null); 
        } finally {
            setLoading(false); // Finalizar el estado de carga
        }
    };

    return (
        // El 'form' usa onSubmit en lugar de un 'onclick' en el botón, es más estándar.
        <form onSubmit={performSearch} className="search-form">
            <p>Ingresa un número de placa, nombre o cualquier texto detectado.</p>
            
            {/* El 'value' se enlaza al estado 'query'. 'onChange' lo actualiza cada vez que se escribe. */}
            <input 
                type="text" 
                value={query} 
                onChange={(e) => setQuery(e.target.value)} 
                placeholder="Ingresa texto de búsqueda..."
                disabled={loading}
            />
            
            <button type="submit" disabled={loading} className="primary-action-button">
                {loading ? 'Buscando...' : 'Buscar'}
            </button>

            {error && <p className="error-message">{error}</p>}
        </form>
    );
}

export default SearchText;